export default __webpack_public_path__ + "static/media/help6.206dd1d4.png";